import { createRoute, redirect } from "@tanstack/react-router";

import { canAccessAskPuntt } from "../../utils/auth";
import { askPunttRoute } from "../ask-puntt/route";
import { authLayoutRoute } from "../auth-layout/route";
import { ticketsRoute } from "../tickets/route";

export const indexRoute = createRoute({
  getParentRoute: () => authLayoutRoute,
  path: "/",
  beforeLoad() {
    throw redirect({
      to: canAccessAskPuntt() ? askPunttRoute.to : ticketsRoute.to,
    });
  },
});
